import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const HOME_TITLE = 'title'
export const CAPTION = 'caption'
export const UPLOAD_FILE = 'uploadFile'
export const TEMPLATES = 'templates'
export const CREATE_NEW = 'createdNew'

export default {
  [PORTUGUESE]: {
    [HOME_TITLE]: 'Carregue sua pesquisa ou crie do zero',
    [CAPTION]: 'Selecione sua escolha abaixo, é fácil e rápido!',
    [UPLOAD_FILE]: 'Carregar Arquivo',
    [TEMPLATES]: 'Modelos',
    [CREATE_NEW]: 'Crie um novo',
  },

  [ENGLISH]: {
    [HOME_TITLE]: 'Upload your survey or create from scratch',
    [CAPTION]: "Select your choice below, it's easy and fast!",
    [UPLOAD_FILE]: 'Upload File',
    [TEMPLATES]: 'Templates',
    [CREATE_NEW]: 'Create New',
  },

  [SPANISH]: {
    [HOME_TITLE]: 'Sube tu encuesta o créala desde cero',
    [CAPTION]: 'Seleccione una de las opciones a la continuación, es fácil!',
    [UPLOAD_FILE]: 'Subir Archivo',
    [TEMPLATES]: 'Modelos',
    [CREATE_NEW]: 'Crear nuevo',
  },
}
